import { motion } from 'framer-motion';
import Image from 'next/image';
import Alerts from '@/components/Alerts';
import { useState } from 'react';

export default function HeaderBanner({ image, alerts, event, onImageClick }) {
  const [imgError, setImgError] = useState(false);

  // Handle both single image string and images array - always use first image
  const images = Array.isArray(image) ? image : image ? [image] : [];
  const currentImage = images[0]; // Always use the first image

  // Helper function to get the correct image source
  const getImageSrc = (img) => {
    if (!img) return null;
    if (typeof img === 'string') return img;
    if (img.url) return img.url;
    return null;
  };

  const imageSrc = imgError
    ? '/placeholder/placeholder.png'
    : getImageSrc(currentImage);
  const isExternal = imageSrc && imageSrc.startsWith('https://');

  return (
    <section className={`relative overflow-hidden h-[400px]`}>
      {alerts && alerts.length ? (
        <div className="alert-bar absolute top-0 left-0 right-0 z-[8]">
          <Alerts alerts={alerts} />
        </div>
      ) : null}

      <div className={`relative h-full w-full`}>
        {/* Background image */}
        {imageSrc ? (
          <Image
            src={imageSrc}
            alt={
              currentImage?.altText
                ? currentImage.altText
                : `${event ? 'Event' : 'Park'} image`
            }
            fill
            className={`object-cover object-top ${onImageClick ? 'cursor-pointer' : ''} transition-opacity duration-300`}
            onClick={onImageClick || undefined}
            priority
            onError={() => setImgError(true)}
            unoptimized={isExternal}
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center bg-beige-100">
            <Image
              src="/placeholder/placeholder.png"
              alt="Placeholder image"
              fill
              className="object-cover"
            />
          </div>
        )}

        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black opacity-40 z-10"></div>
      </div>
    </section>
  );
}
